import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

/**
 * Sinaliza aos gadgets do dashboard se a tela está em foco
 * (gate do auto-refresh). Extraído de main-dashboard.component.ts
 * para quebrar o ciclo de imports pai <-> gadgets.
 */
@Injectable({ providedIn: 'root' })
export class DashboardFocusService {
  private focus$ = new BehaviorSubject<boolean>(false);
  focusChanged = this.focus$.asObservable();

  setFocus(value: boolean) {
    this.focus$.next(value);
  }
}
